import React, { Fragment } from "react";
import {
  applyPolyfills,
  defineCustomElements,
} from "@reecegroup/web-component-library/dist/loader/index.cjs";
import Spinner from "../Spinner/Spinner";

applyPolyfills().then(() => {
  defineCustomElements();
});

class EnquireForm extends React.Component {
  constructor(props) {
    super(props);
    this.dialogRef = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.state = {
      flowVars: [{ name: "SourceDefaultCountry", type: "String", value: "Australia" },
      { name: "SourceFormHeader", type: "String", value: "Product Enquiry Form" },
      { name: "SourceRequestType", type: "String", value: "Product Enquiry" },
      { name: "SourceProductId", type: "String", value: "" },
      { name: "SourceProductDescription", type: "String", value: "" },
      { name: "SourceURL", type: "String", value: window.location.href },
      { name: "SourcePrivacyPolicyURL", type: "String", value: "" }],
      formCreated: false,
      isButtonVisible: false
    }
  }

  startFlow() {
    // Start the flow with the updated flowVars
    window.$Lightning.createComponent(
      "lightning:flow",
      {},
      "lightningLocator",
      (cmp) => {
        cmp.startFlow("Case_Create_Online_Enquiry", this.state.flowVars);
      }
    );
  }

  componentDidMount() {
    this.checkDocumentReady();
    this.attachDialogCloseListener();
  }

  attachDialogCloseListener() {
    if (this.dialogRef.current) {
      this.dialogRef.current.addEventListener('rg-dialog-close', this.handleDialogClose);
    }
  }
  componentWillUnmount() {
    if (this.dialogRef.current) {
      this.dialogRef.current.removeEventListener('rg-dialog-close', this.handleDialogClose);
    }
  }


  checkDocumentReady() {
    if (document.readyState === 'complete') {
      this.setState({ isButtonVisible: true });
    } else {
      window.addEventListener('load', () => {
        this.setState({ isButtonVisible: true });
      });
    }
  }

  handleClick() {
    var link = "";
    if (window.location.origin === "https://www.actrol.co.nz") {
      link = window.location.origin + "/privacy-policy/";
    } else {
      link = window.location.origin + "/privacy";
    }

    // Clear any existing form instance
    const lightningLocator = document.getElementById("lightningLocator");
    if (lightningLocator) {
      lightningLocator.innerHTML = "";
    }

      const newFlowVars = [...this.state.flowVars];
      newFlowVars[3].value = this.props.templateContext.productCode;
      newFlowVars[4].value = this.props.templateContext.productTitle;
      newFlowVars[6].value = link;
      this.setState({ flowVars: newFlowVars, formCreated: true }, () => {
        this.dialogRef.current.show();
        this.fixCloseButtonIcon();
        this.startFlow()
      });
  }

  fixCloseButtonIcon() {
    const dialog = this.dialogRef.current;
    if (!dialog || !dialog.shadowRoot) return;
    const style = document.createElement('style');
    style.textContent = '.zmdi-close:before { content: "\\00d7" !important; }';

    const rgIcon = dialog.shadowRoot.querySelector('rg-icon');
    if (rgIcon && rgIcon.shadowRoot) {
      rgIcon.shadowRoot.appendChild(style);
    } else {
      dialog.shadowRoot.appendChild(style);
    }
  }

  handleDialogClose() {
    // Reset form status when dialog is closed
    this.setState({ formCreated: false });
  }

  render() {
    return (
      <Fragment>
        <rg-dialog id="make-an-enquiry" ref={this.dialogRef}>
          <rg-grid gap="small" align-vertical="middle" slot="header">
            <rg-grid-item max-width="4-5">
              <h5>{this.props.templateContext.productTitle}</h5>
              <rg-text-meta>
                Product code: {this.props.templateContext.productCode}
              </rg-text-meta>
            </rg-grid-item>
          </rg-grid>
          <div className="enquire-form-lineseparater" />
            <style>
              {`
              
              .enquire-form-lineseparater {
                  border-top: 1px solid #d7d7d7;
                  margin-bottom: 16px;
                }
                
                rg-dialog:not([open])::part(base) {
                  display: none !important;
                }
                
                #lightningLocator .slds-card__body {
                  padding: 10px;
                  border-radius: 12px;
                  font-family: Helvetica !important;
              }
          
          
              .slds-scope {
                  margin-bottom: 40px !important;
              }
          
              .slds-scope .slds-input {
                  background-color: #EBEAEB !important;
                  border: none !important;
                  border-radius: 0px !important;
                  height: 40px !important;
                  color: black;
              }
          
              .slds-scope .slds-select {
                  background-color: #EBEAEB !important;
                  border: none !important;
                  border-radius: 0px !important;
                  height: 40px !important;
                  color: black !important;
              }
          
              .slds-scope .slds-input_faux {
                  background-color: #EBEAEB !important;
                  border: none !important;
                  border-radius: 0px !important;
                  height: 40px !important;
              }
          
              .slds-scope .slds-textarea {
                  background-color: #EBEAEB !important;
                  border: none !important;
                  border-radius: 0px !important;
                  font-style: normal;
                  color: black !important
              }
          
              .slds-scope .slds-checkbox .slds-checkbox_faux {
                  background-color: #EBEAEB !important;
              }
          
              .slds-scope .slds-truncate {
                  padding: 5px 10px !important;
                  font-style: normal;
                  color: black;
              }

              slds-tile__title slds-truncate {
                margin: 0px !important; 
              }
          
              .slds-scope .slds-select_container .slds-select {
                  padding: 10px !important;
                  font-style: normal;
                  color: black
              }
          
              .slds-scope .slds-file-selector__dropzone {
                  border: none !important;
              }
          
              .slds-scope .slds-dropdown-trigger .slds-dropdown {
                  font-size: 12px !important;
              }
          
              .slds-scope .slds-input {
                  font-style: normal;
                  color: black !important
              }
          
              .slds-scope .slds-button_brand {
                font-size: 12px;
                padding: 7px 14px !important;
                background-color: #003057;
              }

              .slds-scope .slds-file-selector__button {
                color: #000000 !important;
                padding: 5px 10px !important;
              }
            
              .slds-file-selector__text{
                color: rgb(153,153,153)
              }
          
              .contactus .grey-bg a{
                  font-size: 14px;
              }

              .slds-scope .slds-select_container:after {
                bottom : calc((var(--lwc-lineHeightButtonSmall, 3rem) / 2) + 5px) !important;
              }
    
              .slds-scope .slds-select_container:before {
                display: none !important;
              }
          
          
              #lightningLocator .slds-form-element__label {
                  font-size: 14px;
                  font-family: Helvetica;
                  color: black;
                  font-style: normal;
                  font-weight: normal;
              }
          
              #lightningLocator .slds-form-element__control {
                  font-size: 14px;
                  font-family: Helvetica;
                  color: #999;
                  font-style: italic;
              }
          
              #lightningLocator .slds-form-element__help {
                  font-size: 12px;
              }
          
              #lightningLocator .slds-rich-text-editor__output {
                  font-size: 14px;
              }
          
              .slds-scope .slds-button_brand:focus {
                  box-shadow: none !important;
              }
              
              .footerContainer {
                  font-size: 14px;
                  width: 18%;
              }
          
              .cFieldSection,
              .slds-rich-text-editor__output {
                  font-size: 14px;
              }
          
              #lightningLocator .slds-rich-text-editor__output {
                  font-size: 14px;
                  color: black;
              }
          
          
              @media (min-width : 1200px) {
                  .container {
                      width: 100% !important;
                  }
              }
          
              @media (min-width : 800px) {
                  .container {
                      width: 100% !important;
                  }
              }
              `}
            </style>
          <div id="lightningLocator"></div>
        </rg-dialog>
        {this.state.isButtonVisible && <Button onclick={this.handleClick}></Button>}
        {!this.state.isButtonVisible && <Spinner size="30px" />}
      </Fragment>
    );
  }
}

const Button = ({ onclick }) => (
  <a
    className="pdp-main-block__btn pdp-main-block__btn--enquire-only"
    onClick={onclick}
  >
    Enquire Now
  </a>
);

export default EnquireForm;
